<template>
    <div>
        <!-- TAB HEAD  -->
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <span class="link-a cur-p" @click="back()">
                        RETURN PARTS</span
                    >
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>

        <div id="printDiv">
            <!-- Main ใช้ทั้งสองอัน -->
            <div id="main">
                <v-row>
                    <v-col cols="4"> </v-col>
                    <v-col cols="5">
                        <div
                            style="
                                margin-top: 36px;
                                font-size: 28px;
                                font-weight: bold;
                            "
                        >
                            {{ text_h_how }}
                        </div>
                    </v-col>
                    <v-col cols="3" style="text-align: right">
                        <img
                            style="text-align: right; width: 75px; height: 75px"
                            src="../../assets/odm/HPBLUE.png"
                    /></v-col>
                </v-row>
                <hr
                    style="
                        margin-left: 15px;
                        width: 905px;
                        border: 1px solid black;
                        margin-top: -1px;
                    "
                />
                <v-row class="ml-1 mr-1">
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">Engineer Name:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.ce_name
                                }}</span></v-col
                            >
                        </v-row>
                    </v-col>
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">Engineer Site ID:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.hp_siteid
                                }}</span></v-col
                            >
                        </v-row>
                    </v-col>
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">Engineer Phone Number:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.ce_tel
                                }}</span></v-col
                            >
                        </v-row></v-col
                    >
                </v-row>

                <v-row class="ml-1 mr-1">
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">Case ID:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.case_id
                                }}</span></v-col
                            >
                        </v-row>
                    </v-col>
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">PO-NUMBER:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.ponumber
                                }}</span></v-col
                            >
                        </v-row>
                    </v-col>
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">RMA Number:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.rma
                                }}</span></v-col
                            >
                        </v-row></v-col
                    >
                </v-row>

                <v-row class="ml-1 mr-1">
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">Customer Name:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.customer_name
                                }}</span></v-col
                            >
                        </v-row>
                    </v-col>
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12"
                                >Customer Unit Serial Number:</v-col
                            >
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.product_serial
                                }}</span></v-col
                            >
                        </v-row>
                    </v-col>
                    <v-col cols="4" style="border: 1px black ridge">
                        <v-row>
                            <v-col cols="12">Part Number:</v-col>
                            <v-col cols="12"
                                ><span style="margin-left: 90px">{{
                                    data_print.part_name
                                }}</span></v-col
                            >
                        </v-row></v-col
                    >
                </v-row>

                <v-row class="mt-2">
                    <v-col cols="12">
                        <p><b>Segments :</b></p>
                    </v-col>
                </v-row>
                <v-row style="margin-top: -10px">
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                        <table style="border-collapse: collapse" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <!-- <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i> -->
                                    <img
                                        v-if="data_print.product_group == 'PSG'"
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">PSG</span>
                                </td>
                            </tr>
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <!-- หาคำสั่งช่องว่างยังไม่ได้เลยฟิกแบบนี้ไปก่อน -->
                                    <!-- <span style="color:#FFFF">.</span> -->
                                    <span style="color: white"> .</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table style="border-collapse: collapse" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <!-- <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i> -->
                                    <img
                                        v-if="data_print.product_group == 'IPG'"
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">IPG</span>
                                </td>
                            </tr>
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <!-- หาคำสั่งช่องว่างยังไม่ได้เลยฟิกแบบนี้ไปก่อน -->
                                    <!-- <span style="color:#FFFF">.</span> -->
                                    <span style="color: white"> .</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table style="border-collapse: collapse" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <!-- <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i> -->

                                    <img
                                        v-if="
                                            data_print.project_name == 'S-Print'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">S-Print</span>
                                </td>
                            </tr>
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <!-- หาคำสั่งช่องว่างยังไม่ได้เลยฟิกแบบนี้ไปก่อน -->
                                    <!-- <span style="color:#FFFF">.</span> -->
                                    <span style="color: white"> .</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table style="border-collapse: collapse" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <!-- หาคำสั่งช่องว่างยังไม่ได้เลยฟิกแบบนี้ไปก่อน -->
                                    <!-- <span style="color:#FFFF">.</span> -->
                                    <span style="color: white"> .</span>
                                </td>
                            </tr>
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <!-- หาคำสั่งช่องว่างยังไม่ได้เลยฟิกแบบนี้ไปก่อน -->
                                    <!-- <span style="color:#FFFF">.</span> -->
                                    <span style="color: white"> .</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>

                <!-- <v-row class="mt-1">
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">BCS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">NETW</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">MVS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <i
                                        class="fa fa-check fa-xs"
                                        aria-hidden="true"
                                    ></i>
                                </td>

                                <td align="center" width="100px">
                                    <span class="font-18">OTHERS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row> -->

                <v-row class="mt-2">
                    <v-col cols="12">
                        <p><b>Qualification: ลักษณะกล่องที่ได้รับ</b></p>
                    </v-col>
                </v-row>

                <v-row style="margin-top: -10px">
                    <v-col cols="1"></v-col>
                    <v-col cols="5">
                        <table
                            style="border-collapse: collapse"
                            width="80%"
                            border="1"
                        >
                            <tr>
                                <td align="center" width="18%">
                                    <img
                                        v-if="
                                            data_print.return_box_status ===
                                            'new'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td align="center" width="82%">
                                    <span class="font-18"
                                        >NEW Shipment(เปิดกล่องใหม่)</span
                                    >
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="6">
                        <table
                            style="border-collapse: collapse"
                            border="1"
                            width="80%"
                        >
                            <tr>
                                <td align="center" width="18%">
                                    <img
                                        v-if="
                                            data_print.return_box_status ===
                                            'used'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td align="center" width="82%">
                                    <span class="font-18"
                                        >Unused
                                        Return(เป็นกล่องที่เปิดใช้มาก่อน)</span
                                    >
                                </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
            </div>

            <div v-if="chk_status === 'Good'">
                <v-row class="mt-2">
                    <v-col cols="12">
                        <p><b>UNUSED Reasons</b></p>
                    </v-col>
                </v-row>
                <table
                    width="100%"
                    border="1"
                    style="border-collapse: collapse"
                >
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="
                                    data_print.return_reason ===
                                        'wrongorder-dbd' ||
                                    data_print.return_reason === 'wrongorder-ce'
                                "
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col class="fix-col-print-a" cols="5">
                                    <span class="ml-5"
                                        >Wrong Part Ordered(เบิก Part
                                        ไม่ถูกต้อง)</span
                                    >
                                </v-col>
                                <v-col
                                    class="fix-col-print-a text-center"
                                    style="
                                        border-left: 1pt solid black;
                                        border-right: 1pt solid black;
                                    "
                                    cols="1"
                                    ><img
                                        v-if="
                                            data_print.return_reason ===
                                            'wrongorder-dbd'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                /></v-col>
                                <v-col class="fix-col-print-a" cols="2">
                                    <span class="ml-2">From DBD</span></v-col
                                >

                                <v-col
                                    class="fix-col-print-a text-center"
                                    style="
                                        border-left: 1pt solid black;
                                        border-right: 1pt solid black;
                                    "
                                    cols="1"
                                >
                                    <img
                                        v-if="
                                            data_print.return_reason ===
                                            'wrongorder-ce'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </v-col>
                                <v-col class="fix-col-print-a" cols="3">
                                    <span class="ml-2"> From CE </span></v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'mismatch'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <span class="ml-5"
                                >Wrong Part Received(Part ในกล่องไม่ตรงกับเลข
                                Part ข้างกล่อง)</span
                            >
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="
                                    data_print.return_reason ===
                                        'cust-cancel' ||
                                    data_print.return_reason ===
                                        'cust-reschedule'
                                "
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col class="fix-col-print-a" cols="5">
                                    <span class="ml-5"
                                        >Customer considering</span
                                    ></v-col
                                >
                                <v-col
                                    class="fix-col-print-a text-center"
                                    style="
                                        border-left: 1pt solid black;
                                        border-right: 1pt solid black;
                                    "
                                    cols="1"
                                >
                                    <img
                                        v-if="
                                            data_print.return_reason ===
                                            'cust-cancel'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </v-col>
                                <v-col class="fix-col-print-a" cols="2">
                                    <span class="ml-2">Cancel Job</span>
                                </v-col>
                                <v-col
                                    class="fix-col-print-a text-center"
                                    style="
                                        border-left: 1pt solid black;
                                        border-right: 1pt solid black;
                                    "
                                    cols="1"
                                >
                                    <img
                                        v-if="
                                            data_print.return_reason ===
                                            'cust-reschedule'
                                        "
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </v-col>
                                <v-col class="fix-col-print-a" cols="3">
                                    <span class="ml-2">
                                        Re-schedule more 7 Day</span
                                    ></v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="
                                    data_print.return_reason === 'complex-issue'
                                "
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <span class="ml-5"
                                >Complex Issues an expected more parts to
                                resolve</span
                            ><br /><span class="ml-5"
                                >(พบปัญหาที่ซับซ้อนและแนะนำ Parts
                                ที่คาดว่าจะแก้ไขปัญหาได้ แต่ไม่ได้ใช้
                                Part)</span
                            >
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'quotation'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <span class="ml-5"
                                >Quotation Cases with Approved but Customer
                                changed their mind to Cancelled</span
                            >
                            <br /><span class="ml-5">
                                (เคสเสนอราคาและมีการอนุมัติการซ้อมเเล้ว
                                แต่ลูกค้าเปลี่ยนเป็นยกเลิกงานซ่อม)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'others-1'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <span class="ml-5"
                                >Others please specify(อื่นๆ โปรดระบุ):
                                {{ data_print.return_remark }}
                            </span>
                        </td>
                    </tr>
                </table>

                <v-row class="mt-1">
                    <v-col cols="12" class="text-right">
                        <span style="font-size: 12px"
                            ><b>UNUSED PARTS RETURN: Revision 1.01</b></span
                        >
                    </v-col>
                </v-row>
            </div>

            <div v-if="chk_status === 'DOA'">
                <v-row class="mt-2">
                    <v-col cols="12">
                        <p><b>DOA Type:</b></p>
                    </v-col>
                </v-row>
                <table
                    width="100%"
                    border="1"
                    style="border-collapse: collapse"
                >
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'newpart'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col col="4"
                                    ><span class="ml-1"
                                        >DOA/Functional Failure (55)</span
                                    ></v-col
                                >
                                <v-col col="8" style="margin-left: -20px"
                                    >Part
                                    ที่ได้รับการอยู่ในสภาพดีแต่ใช้งานไม่ได้</v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'returnpart'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col col="4"
                                    ><span class="ml-1"
                                        >DOA/Return good before (55)</span
                                    ></v-col
                                >
                                <v-col col="8" style="margin-left: -20px"
                                    >เป็น Part ที่คืน Good
                                    มาก่อนหน้าที่จะได้รับอยู่ในสภาพดี
                                    แต่ใช้งานไม่ได้</v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'defective'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col col="4"
                                    ><span class="ml-1"
                                        >Physically Damaged (PD)**</span
                                    ></v-col
                                >
                                <v-col col="8" style="margin-left: -20px"
                                    >Part ในกล่องที่ได้รับ
                                    เกิดความเสียหายมาก่อนหน้านี้เเล้ว</v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'invalid'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col col="4"
                                    ><span class="ml-1"
                                        >Missing parts or accessories
                                        (PM)**</span
                                    ></v-col
                                >
                                <v-col col="8" style="margin-left: -20px"
                                    >Part ที่ได้รับ มีชิ้นส่วนไม่ครบ</v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'acc-lost'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col col="4"
                                    ><span class="ml-1"
                                        >Assembly Issue (AI)**</span
                                    ></v-col
                                >
                                <v-col col="8" style="margin-left: -20px"
                                    >Part ที่ได้รับมีชิ้นส่วนประกอบ
                                    บนอุปกรณ์ขาดหายไป</v-col
                                >
                            </v-row>
                        </td>
                    </tr>
                    <tr>
                        <td width="5%" align="center">
                            <img
                                v-if="data_print.return_reason === 'others-2'"
                                style="
                                    text-align: right;
                                    width: 15px;
                                    height: 15px;
                                "
                                src="../../assets/all/check.png"
                            />
                        </td>
                        <td width="95%">
                            <v-row>
                                <v-col cols="12">
                                    <span class="ml-1">
                                        <b style="background-color: #bdbdbd"
                                            >ระบุอาการเพิ่มเติมของชิ้นงานที่เกิดปัญหา
                                            (pls specify failure symptom,
                                            diagnostic)</b
                                        ></span
                                    >
                                </v-col>
                            </v-row>
                            <span class="ml-1" style="margin-bottom: 10px">{{
                                data_print.return_remark
                            }}</span>
                            <br />
                            <br />
                            <hr
                                style="
                                    width: 925px;
                                    border: 1px solid black;
                                    margin-left: 3px;
                                "
                            />
                        </td>
                    </tr>
                </table>

                <v-row>
                    <v-col cols="12" class="text-center mar-t-10">
                        <b style="background-color: #bdbdbd"
                            >"Pls systematically feedback within 24 hrs. for all
                            case"</b
                        >
                    </v-col>
                </v-row>
                <table
                    width="100%"
                    border="1"
                    style="border-collapse: collapse; margin-top: 20px"
                >
                    <tr>
                        <td align="center">
                            <span
                                >** if DOA is PD, PM and AI. Please provide the
                                picture of that part attached to the box
                                **</span
                            >
                            <br /><span
                                >** if DOA Type ที่พบคือ PD, PM and AI
                                โปรดแนบรูปของ Part ดังกล่าวมาในกล่องด้วย
                                **</span
                            >
                        </td>
                    </tr>
                </table>

                <v-row class="mt-1">
                    <v-col cols="12" class="text-right">
                        <span style="font-size: 12px"
                            ><b>UNUSED PARTS RETURN: Revision 2.01</b></span
                        >
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.part_issue_id = this.$route.params.part_issue_id
        this.get_data()
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "engineer/return-part-view/" + this.part_issue_id)
                .then((response) => {
                    // console.log(response)
                    this.mutateIsLoading()
                    this.data_print = response.data
                    this.chk_status = response.data.ce_status
                    this.chk_status === "DOA"
                        ? (this.text_h_how = "DOA FAILURE REPORT")
                        : (this.text_h_how = "UNUSED PARTS RETURN")
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        back() {
            if (this.role_type == "Engineer") {
                this.$router.push("/Onsite/Main/Return-Part")
            } else {
                this.$router.push("/Return-Part")
            }
        },
        print() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/landscape.css",
                ],
            }

            this.$htmlToPaper("printDiv", localOptions, () => {
                // console.log(localOptions)
                // console.warn("done landscape")
            })
        },
    },
    data() {
        return {
            data_print: [],
            part_issue_id: 0,
            chk_status: "",
            text_h_how: "",
            role_type: localStorage.role_type,
        }
    },
}
</script>

<style scoped>
.fix-col-print-a {
    padding: 0px !important;
}
</style>
